import { VersionFirebase } from '../interfaces/version-firebase.interface';
import { Address } from './address.model';
import { LastGeoPosition } from './last-geoposition.model';
import { LastOrderConfig } from './order/last-order-config.model';
import { Store } from './store.model';
import { Table } from './table.model';

export class LocalConfig {
  remoteVersion: VersionFirebase;
  lastGeoPosition: LastGeoPosition;
  lastStore: { store: Store; date: number };
  lastTable: { table: Table; date: number };
  lastOrderConfig: LastOrderConfig;

  // Endereço utilizado na tela inicial
  addressToSearch: Address;

  // Já conseguimos obter a localização deste usuário alguma vez, ou seja: ele já concedeu a
  // permissão em algum momento. Usado só para decidir se ainda vale mostrar a explicação antes do
  // prompt — quem já concedeu não precisa ser convencido de novo.
  // Não serve para saber se o acesso funciona AGORA (a permissão pode ter sido revogada ou expirada).
  locationAccessEverGranted: boolean;
}
